import { v4 as uuid4 } from "uuid";

const getOrCreateId = () => {
  let visitorId = localStorage.getItem("vid");
  if (!visitorId) {
    visitorId = uuid4();
    localStorage.setItem("vid", visitorId);
  }
  return visitorId;
}

export const visitorServices = {
  getOrCreateId,
};